import BypassInfoModalContainer from './containers/BypassInfoModalContainer'

export default BypassInfoModalContainer
